const getLineItemBody = ({ lineItem , labels  })=>{
    const lineItemFields = {
        quantity: '',
        subtitle: lineItem.subtitle || ''
    };
    switch(lineItem.type){
        case 'CONTACT_LENSES':
            const eyeSideLabel = lineItem.eyeSide === 'left' ? labels.leftEye : labels.rightEye;
            lineItemFields.quantity = `${lineItem.quantity} | ${eyeSideLabel}`;
            return lineItemFields;
        case 'SOLUTION':
            lineItemFields.subtitle = `${lineItem.solutionType} ${lineItem.solutionVolume}${labels.unitMilli}`;
        default:
            if (lineItem.power) {
                lineItemFields.subtitle = `${labels.power}: ${lineItem.power}`;
            }
            lineItemFields.quantity = lineItem.quantity;
            return lineItemFields;
    }
};

export { getLineItemBody };
//# sourceMappingURL=get-product-body.js.map
